/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Below_ReceivedInputs */

const en_po_issue_below_received = /** @type {(inputs: Po_Issue_Below_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is below what was already received`)
};

/**
* | output |
* | --- |
* | "is below what was already received" |
*
* @param {Po_Issue_Below_ReceivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_below_received = /** @type {((inputs?: Po_Issue_Below_ReceivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Below_ReceivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_below_received(inputs)
});